/*
 * Frontend bootstrap javascript
 *
 * All plugins you want to use can be listed below
 * Do NOT forgot to add comments above the different functions or functionalities that need explaining.
 *
 */
// jQuery 
window.jQuery = require('jquery');
window.$ = window.jQuery;

/**
 * Load Foundation and plugins
 * @credits: https://github.com/zurb/foundation-sites/blob/v6.4.3/js/entries/foundation.js
 * @author Rick van der Burg <rick@click.nl>
 */
import {Foundation} from 'foundation-sites/js/foundation.core';
Foundation.addToJquery($);

import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.MediaQuery = MediaQuery;

import { Box } from 'foundation-sites/js/foundation.util.box'
Foundation.Box = Box;


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/bootstrap.js